<div class="dashboard-container">
  <div class="filter-section animate-fade-in-up">
    <div class="filter-header">
      <div class="page-header">
        <div class="title-wrapper">
          <h2 class="header-title">Dashboard</h2>
          <span class="header-subtitle">Track your recruitment performance and candidate insights at a glance.</span>
        </div>
      </div>
      <div class="filter-controls">
        <div class="animate-fade-in-up delay-1">
          <mat-form-field appearance="outline" class="premium-select">
            <mat-label>Filter Range</mat-label>
            <mat-select [(value)]="selectedFilter" (selectionChange)="filterChange($event)"
              panelClass="mySelectedPanel">
              <mat-option [value]="option.id" *ngFor="let option of filterOptions">{{ option.value }}</mat-option>
              <mat-option [value]="'custom'" (click)="rangePicker.open()">Custom</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" class="example-form-field" style="width:1px;visibility:hidden;">
            <mat-date-range-input [rangePicker]="rangePicker" [formGroup]="startEndDateSelection" [max]="todayDate">
              <input matStartDate placeholder="Start date" formControlName="start">
              <input matEndDate placeholder="End date" formControlName="end">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>Cancel</button>
                <button mat-raised-button color="primary" matDateRangePickerApply
                  (click)="applyCustomRange()">Apply</button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="metrics-section">
    <ng-container *ngIf="results?.length; else noData">
      <div *ngFor="let item of results; let i = index" class="item animate-fade-in-up" [class]="'delay-' + (i + 1)">
        <div class="heading">{{item.label}}</div>
        <div class="card">
          <div class="icon-section">
            <span class="icon">
              <img [src]="item.icon" [alt]="item.title">
            </span>
          </div>
          <div class="count">{{item.count}}</div>
          <div class="percentage" *ngIf="item.percentage">
            {{item.percentage | fixDecimal}}% {{item.phrase}}
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noData>
      No data available.
    </ng-template>
  </div>
  <div class="logs-section animate-fade-in-up delay-3">
    <div class="activity-log-section">
      <div class="heading">Activity log</div>
      <div class="card activity-log-card">

        <ng-container *ngIf="activityLog && activityLog.length; else elseTemplate">
          <div *ngFor="let item of activityLog" class="item" (click)="activityLogDetails(item.assessmentId)"
            [ngClass]="getActivityColor(item.notification)">
            <div class="activity-icon">
              <i class="material-icons">{{getActivityIcon(item.notification)}}</i>
            </div>
            <div class="activity-content">
              <div class="notification-text">
                <span [innerHTML]="formatNotification(item.notification)"></span>
              </div>
              <div class="timestamp">{{ (item.createdAt | date:'MMM d, h:mm a') || 'Just now' }}</div>
            </div>
          </div>
        </ng-container>
        <ng-template #elseTemplate>
          <div class="no-data">
            <div class="no-logs-wrapper">
              <img src="../../../assets/no-assessment-icon.svg" class="no-logs-icon" alt="No activity logs">
              <div class="no-data-text">No activity yet.</div>
              <div class="no-data-subtext">Start inviting candidates to see your activity log.</div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="insights-recommendations">
      <div class="insights-section"
        *ngIf="assessmentStats?.insights?.qualifiedCandidates > 0 || assessmentStats?.insights?.candidateQuality > 0">
        <div class="heading">Insights</div>
        <div class="card">
          <div class="insight-item">
            <div class="qualified-label">Qualified candidates</div>
            <div>
              <div class="average">{{assessmentStats?.insights?.qualifiedCandidates}} average</div>
              <div class="avg-label">Per assessment</div>
            </div>
          </div>
          <div class="insight-item">
            <div class="quality-label">Candidate quality</div>
            <div>
              <div class="quality">{{assessmentStats?.insights?.candidateQuality}}% Qualify</div>
              <div class="quality-label">For all assessment</div>
            </div>
          </div>
        </div>
      </div>
      <div class="recommendations-section" *ngIf="assessmentStats?.recommendations?.length">
        <div class="heading">Recommendations</div>
        <div class="card">
          <div *ngFor="let item of assessmentStats?.recommendations">{{item}}</div>
        </div>
      </div>
    </div>
  </div>
</div>